import { IBookFromPreviousTableStrategy } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/interfaces/book-from-previous-table-strategy.interface';
import { ESortOrder } from '@aca-new/app/shared/components/data-table/shared/models/enums/sort-order.enum';
import { IDataTableQueryParams } from '@aca-new/app/shared/components/data-table/shared/models/interfaces/data-table-query-params.interface';
import { ITableHeader } from '@aca-new/app/shared/components/table/shared/interfaces/table-header.interface';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { SERVICE_TYPE, SERVICE_DATE, REF_NO, SUPPLIER, PO_NO } from '@aca-new/app/shared/constants/table-header.constants';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { Injectable } from '@angular/core';
import { assign, cloneDeep, pickBy } from 'lodash/index';

@Injectable()
export class AuditsTableStrategyService implements IBookFromPreviousTableStrategy {
  public readonly userId: string = this._storageService.getItem(EStorageKeys.USER_ID);

  public tableUrlPath: string = `${SERVER_URL}/user/${this.userId}/audit-orders`;

  public tableHeaders: ITableHeader[] = [
    assign(cloneDeep(SERVICE_TYPE), { key: 'serviceType', isFrontSort: true }),
    assign(cloneDeep(SERVICE_DATE), {
      key: 'serviceDate',
      sortKey: 'serviceDate',
      isFrontSort: true,
      width: '120',
      sortFunction(a: { label: string }, b: { label: string }, sortOrder: ESortOrder): number {
        const dateA = new Date(a.label).getTime();
        const dateB = new Date(b.label).getTime();

        return sortOrder === ESortOrder.ASC ? dateA - dateB : dateB - dateA;
      },
    }),
    assign(cloneDeep(SUPPLIER), { key: 'supplierName', isFrontSort: true, width: '100' }),
    assign(cloneDeep(PO_NO), { key: 'clientReference', isFrontSort: true, width: '120' }),
    assign(cloneDeep(REF_NO), { key: 'refNumber', isFrontSort: true, width: '118' }),
  ];

  public constructor(protected readonly _storageService: StorageService) {}

  public getTableUrlParams(tableParams: IDataTableQueryParams): Record<string, string> {
    return pickBy({
      'service-type': 'ma,ea,enva,stra,ctpat,dr', // eslint-disable-line @typescript-eslint/naming-convention
      'keyword': tableParams.keyword,
      'page-size': tableParams.pageSize.toString(), // eslint-disable-line @typescript-eslint/naming-convention
      'page': tableParams.page.toString(),
    }) as Record<string, string>;
  }
}
